import { STORAGE_KEYS } from "../constants/userConstant";
import { GUEST_CART_STORAGE_KEY } from "../constants/guestConstants";

const AUTH_SESSION_KEYS = [STORAGE_KEYS.TOKEN, STORAGE_KEYS.ACCESS_TOKEN, STORAGE_KEYS.LOGIN_TIMESTAMP];
const APP_STORAGE_KEYS = [...new Set([...Object.values(STORAGE_KEYS), GUEST_CART_STORAGE_KEY])];

const getSessionStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage;
};

const getLocalStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage;
};

const getValue = (storage, key) => storage?.getItem(key) || "";

const setValue = (storage, key, value) => {
  if (!storage) {
    return;
  }

  if (value) {
    storage.setItem(key, value);
    return;
  }

  storage.removeItem(key);
};

export const getAuthTokens = () => {
  const sessionStorage = getSessionStorage();

  return {
    bearerToken: getValue(sessionStorage, STORAGE_KEYS.TOKEN),
    accessToken: getValue(sessionStorage, STORAGE_KEYS.ACCESS_TOKEN),
  };
};

export const setAuthTokens = ({ bearerToken = "", accessToken = "" }) => {
  const sessionStorage = getSessionStorage();

  setValue(sessionStorage, STORAGE_KEYS.TOKEN, bearerToken);
  setValue(sessionStorage, STORAGE_KEYS.ACCESS_TOKEN, accessToken);
};

export const clearAuthTokens = () => {
  const sessionStorage = getSessionStorage();

  AUTH_SESSION_KEYS.forEach((key) => {
    sessionStorage?.removeItem(key);
  });
};

export const getLoginTimestamp = () => {
  const sessionStorage = getSessionStorage();
  return getValue(sessionStorage, STORAGE_KEYS.LOGIN_TIMESTAMP);
};

export const setLoginTimestamp = (timestamp = `${Date.now()}`) => {
  const sessionStorage = getSessionStorage();
  setValue(sessionStorage, STORAGE_KEYS.LOGIN_TIMESTAMP, timestamp);
};

export const setStoredUser = (user) => {
  const localStorage = getLocalStorage();

  if (!localStorage) {
    return;
  }

  if (user) {
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    return;
  }

  localStorage.removeItem(STORAGE_KEYS.USER);
};

export const getStoredUser = () => {
  const localStorage = getLocalStorage();
  const rawUser = localStorage?.getItem(STORAGE_KEYS.USER);

  if (!rawUser) {
    return {};
  }

  try {
    return JSON.parse(rawUser);
  } catch (error) {
    localStorage?.removeItem(STORAGE_KEYS.USER);
    return {};
  }
};

export const setAuthSession = (authData = {}) => {
  setAuthTokens({
    bearerToken: authData.authorizationToken,
    accessToken: authData.accessToken,
  });
  setStoredUser(authData);
  setLoginTimestamp();
};

export const isAuthenticated = () => {
  const { bearerToken } = getAuthTokens();
  return Boolean(bearerToken);
};

export const clearAppStorage = () => {
  const localStorage = getLocalStorage();
  const sessionStorage = getSessionStorage();

  APP_STORAGE_KEYS.forEach((key) => {
    localStorage?.removeItem(key);
    sessionStorage?.removeItem(key);
  });
};